import React from "react"
import { I18n } from "react-redux-i18n";

import Dropdown from "@alboompro/boom-components/data-display/dropdown"
import Icon from "@alboompro/boom-components/general/icon";

import { 
  DropdownIconWrapper, 
  DropdownOverlayButton, 
  DropdownOverlayWrapper 
} from "./styles";

const QuestionDropdown = ({
  index,
  itemId,
  dropdownOpenedId,
  handleDropdownClick,
  duplicateQuestion,
  removeQuestion
}) => {
  return (
    <Dropdown 
      align="left"
      onVisibleChange={() => handleDropdownClick(itemId)}
      visible={dropdownOpenedId === itemId}
      overlayStyle={{
        width: 'auto',
        minWidth: '145px',
        padding: '7px',
      }}
      overlay={
        <DropdownOverlayWrapper>
          <DropdownOverlayButton 
            type="button" 
            onClick={() => duplicateQuestion(index)}
          >
            <Icon 
              kind="bold" 
              group="files-folders" 
              category="common-files" 
              file="common-file-double-1-alternate.svg" 
              size="14" 
              color="#4F4F4F" 
            />
            <span>{I18n.t("editPanel.FAQManager.duplicateQuestion")}</span>
          </DropdownOverlayButton>
          <DropdownOverlayButton 
            type="button" 
            removeButton
            onClick={() => removeQuestion(itemId)}
          >
            <Icon 
              kind="regular" 
              group="interface-essential" 
              category="delete" 
              file="bin-1.svg" 
              size="14" 
              color="#E83535" 
            />
            <span>{I18n.t("editPanel.FAQManager.removeQuestion")}</span>
          </DropdownOverlayButton>
        </DropdownOverlayWrapper>
      }
    >
      <DropdownIconWrapper>
        <Icon 
          kind="bold" 
          group="interface-essential" 
          category="menu" 
          file="navigation-menu-vertical.svg" 
          size="13" 
          color="#8D8D8D"
        />
      </DropdownIconWrapper>
    </Dropdown>
  )
}

export default QuestionDropdown;